import logo from "./logo.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import CatalogoList from "./view/CatalogoList";

function App() {
  return (
    <div className="App">
      <CatalogoList />
    </div>
  );
}

export default App;
